import { useState } from "react";
import { getPrice } from "../../utils/formatter";

export default function MaxPriceBubble({
  onSend,
}: {
  onSend: (text: string) => void;
}) {
  const PRICE_MIN = 0;
  const PRICE_MAX = 100000;
  const PRICE_STEP = 1000;

  const [maxPrice, setMaxPrice] = useState<number>(PRICE_MAX);

  return (
    <div className="vcw-price-slider">
      <div className="vcw-price-slider__header">
        <span className="vcw-price-slider__label">Prix maximum</span>
        <span className="vcw-price-slider__value">{getPrice(maxPrice)} €</span>
      </div>

      <input
        className="vcw-price-slider__range"
        type="range"
        min={PRICE_MIN}
        max={PRICE_MAX}
        step={PRICE_STEP}
        value={maxPrice}
        onChange={(e) => setMaxPrice(Number(e.target.value))}
      />

      <div className="vcw-price-slider__actions">
        <button
          className="vcw-yes-btn"
          onClick={() => onSend(`max ${String(getPrice(maxPrice))} €`)}
        >
          Valider
        </button>
      </div>
    </div>
  );
}
